// extracted by mini-css-extract-plugin
export default {"footerContainer":"SpaceDialogFooter-module__footerContainer--F3oYC"};